module.exports = __webpack_public_path__ + "static/media/foto_01.bfd08d13.jpg";